// Copyright 2026 - Hewlett Packard Enterprise Company

// Build-time constant injected by Vite (see vite.config.js)
/* global __PRODUCT__ */
const PRODUCT = __PRODUCT__;

/**
 * Product capabilities configuration
 *
 * IMPORTANT: Use this approach ONLY as a last resort when:
 * - Both products use the same component AND
 * - Converting the component to accept configuration via props is not possible AND
 * - Product-specific behavior cannot be abstracted into a configurable pattern
 *
 * This centralized capability check should be preferred over scattered
 * product-specific conditionals (e.g., `PRODUCT === 'NUCLEON'`) throughout
 * the codebase. Always try to make components configurable first before
 * adding a new capability flag here.
 *
 * Benefits of this approach:
 * - Single source of truth for product differentiation
 * - Easier to maintain and understand product differences
 * - Prevents anti-pattern of scattered conditional checks
 * - Supports temporary compatibility fixes until product parity is available;
 *   these flags should be removed once the correct implementation is supported
 *
 */
export const PRODUCT_CAPABILITIES = {
  iloUpdateSupport: PRODUCT !== 'NUCLEON',
  groupSupport: PRODUCT !== 'NUCLEON',
  requiresIncludeAllDataOnServers: PRODUCT === 'NUCLEON',
  parentChildJobsSupport: PRODUCT !== 'NUCLEON',
  themePreferenceSupport: PRODUCT === 'COM',
  enforcePlatformFamilyEligibility: PRODUCT !== 'NUCLEON',
  applianceSupport: PRODUCT === 'COM',
  aiSupport: PRODUCT === 'COM',
  schedulerSupport: PRODUCT !== 'NUCLEON',
};
